<template>
  <ValidationObserver v-slot="{ invalid }" ref="observer">
    <unicom-modal
      v-model="mostrar"
      :largura="616"
      fechar
      @input="valor => fecharModal(valor)"
    >
      <div slot="header" class="pb-2">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Justificativa
        </div>
      </div>
      <div slot="body">
        <unicom-linha>
          <!--
          <unicom-coluna sm="12" v-show="tipoAcao !== 'EXCLUIR'">
            <ValidationProvider
              name="nome"
              rules="required"
              mode="aggressive"
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                v-model="objetoContato.nome"
                titulo="Nome"
                placeholder="Escreva o nome do contato"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
          <unicom-coluna sm="12" class="mt-3" v-show="tipoAcao !== 'EXCLUIR'">
            <ValidationProvider
              name="email"
              rules="required|email"
              mode="aggressive"
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                v-model="objetoContato.email"
                titulo="Email"
                placeholder="Escreva o email do contato"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
          
          
          <unicom-coluna sm="12" class="mt-3">
              <unicom-campo-texto
                v-model="objetoClassificacao.dataDeixouDeSerOperadora"
                titulo="Telefone"
                placeholder="Escreva o telefone do contato"
              />
          </unicom-coluna>

          ObjetoClassificacao {{ objetoClassificacao }}
          <br />
-->
          <unicom-coluna sm="12">
            <ValidationProvider
              name="motivoAlteracao"
              :rules="{
                required: true,
                regex: /^(?:(.)(?!\1{2})){3,}$/
              }"
              mode="aggressive"
              v-slot="{ errors }"
            >
              <br />
              <div slot="header">
                Motivo Alteração
              </div>
              <unicom-area-texto
                v-model="objetoClassificacao.motivoAlteracao"
                minCaracteres="3"
                max="300"
                alturaAutomatica
                placeholder="Escreva o motivo"
                spellcheck
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
        </unicom-linha>
      </div>

      <div slot="footer" class="pt-4">
        <unicom-linha justificarItem="end">
          <unicom-coluna
            sm="12"
            md="auto"
            :order="$breakpoint.smAndDown ? 1 : 0"
          >
            <unicom-botao
              class="fonte-secundaria texto"
              @click="$emit('input', false)"
              :altura="40"
              contornado
              :largura="144"
              :bloco="$breakpoint.smAndDown"
              >VOLTAR</unicom-botao
            >
          </unicom-coluna>
          <unicom-coluna sm="12" md="auto" class="pb-2">
            <unicom-botao
              class="fonte-secundaria texto"
              @click="$emit('salvar-modal-classific', objetoClassificacao)"
              :altura="40"
              :largura="144"
              :bloco="$breakpoint.smAndDown"
              :desabilitado="invalid"
              >SALVAR</unicom-botao
            >
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-modal>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
    /*objetoClassificacaoProp: {
      dataDeixouDeSerOperadora: "",
      tipoAtuacao: "",
      motivoAlteracao : ""
    }*/
  },
  data() {
    return {
      mostrar: this.value,
      objetoClassificacao: {
        dataDeixouDeSerOperadora: "",
        tipoAtuacao: "",
        motivoAlteracao: "",
        classificacaoAtuacaoHistoricos: []
      },
      objetoClassificacaoVazio: {
        dataDeixouDeSerOperadora: "",
        tipoAtuacao: "",
        motivoAlteracao: "",
        classificacaoAtuacaoHistoricos: []
      }
    };
  },
  methods: {
    fecharModal(valor) {
      if (!valor) {
        this.objetoClassificacao = JSON.parse(
          JSON.stringify(this.objetoClassificacaoVazio)
        );
        this.$emit("input", false);
      }
    },
    salvar() {},
    editarObjetoClassificacao(objetoClassificacao) {
      this.objetoClassificacao = JSON.parse(
        JSON.stringify(objetoClassificacao)
      );
      if (this.objetoClassificacao.classificacaoAtuacaoHistoricos === null) {
        this.objetoClassificacao.classificacaoAtuacaoHistoricos = [];
      }
    }
  },
  computed: {},
  watch: {
    value() {
      this.mostrar = this.value;
    }
    /*,
    objetoClassificacaoProp: {
      deep: true,
      immediate: true,
      handler() {
        this.objetoClassificacao = JSON.parse(
          JSON.stringify(this.objetoClassificacaoProp)
        );
      }
    }*/
  }
};
</script>

<style lang="scss" scoped></style>
